module.exports = __webpack_public_path__ + "static/browser-rain-trees.33eb9c21.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/browser-rain-trees.png
// module id = 1700
// module chunks = 35783957827783